import { CommonModule } from '@angular/common';
import {
    Component,
    Input,
    Output,
    EventEmitter,
    SimpleChanges,
    OnChanges,
} from '@angular/core';
import { GenericFilterComponent } from 'src/app/common/components/generic-filter/generic-filter.component';

/**
 * Componente para mostrar lista de productos disponibles o seleccionados
 * @since 1.0.0
 */
@Component({
    selector: 'app-lista-productos',
    standalone: true,
    imports: [CommonModule, GenericFilterComponent],
    templateUrl: './lista-productos.component.html',
    styleUrls: ['./lista-productos.component.css'],
})
export class ListaProductosComponent implements OnChanges {
    /** Lista de productos a mostrar */
    @Input() productos: any[] = [];

    /** Tipo de lista: disponibles o seleccionados */
    @Input() tipo: 'disponibles' | 'seleccionados' = 'disponibles';

    /** Función para obtener color por tipo de producto */
    @Input() getTipoColor!: (tipoId: number) => string;

    /** Función para obtener nombre del tipo de producto */
    @Input() getTipoNombre!: (tipoId: number) => string;

    /** Evento emitido al agregar producto */
    @Output() agregarProducto = new EventEmitter<any>();

    /** Evento emitido al quitar producto */
    @Output() quitarProducto = new EventEmitter<any>();

    /** Productos filtrados para mostrar */
    productosFiltrados: any[] = [];

    /**
     * Maneja cambios en las propiedades de entrada
     * @param changes - Cambios en las propiedades
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['productos'] && this.productos) {
            this.productosFiltrados = [...this.productos];
        }
    }

    /** Obtiene el título según el tipo de lista */
    get titulo(): string {
        return this.tipo === 'disponibles'
            ? 'Productos - Presentaciones'
            : 'Productos seleccionados';
    }
}
